import { Download, FileSpreadsheet, FileText, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export type ExportFormat = 'xlsx' | 'pdf' | 'csv'

const FORMAT_LABEL_KEYS: Record<ExportFormat, string> = {
	xlsx: 'common.exportExcel',
	pdf: 'common.exportPdf',
	csv: 'common.exportCsv',
}

interface ExportMenuProps {
	onExport: (format: ExportFormat) => void
	isExporting?: boolean
	disabled?: boolean
	formats?: ExportFormat[]
}

/** Botão padrão de exportação (Excel / PDF / CSV) das listagens. */
export function ExportMenu({
	onExport,
	isExporting = false,
	disabled = false,
	formats = ['xlsx', 'pdf'],
}: ExportMenuProps) {
	const { t } = useTranslation()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					type="button"
					variant="outline"
					disabled={disabled || isExporting}
					className="w-auto shrink-0 gap-2"
				>
					{isExporting ? (
						<Loader2 className="size-4 animate-spin" />
					) : (
						<Download className="size-4" />
					)}
					<span>
						{isExporting ? t('common.exporting') : t('common.export')}
					</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{formats.map((format) => {
					const Icon = format === 'pdf' ? FileText : FileSpreadsheet
					return (
						<DropdownMenuItem key={format} onSelect={() => onExport(format)}>
							<Icon className="size-4" />
							{t(FORMAT_LABEL_KEYS[format])}
						</DropdownMenuItem>
					)
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
